// https://docs.google.com/spreadsheets/d/1ac0EPXTwPfrGD224AbkL1GoMzlGaGLBOZDSbCWHZTi4
export const SPREAD_SHEET_ID = '1ac0EPXTwPfrGD224AbkL1GoMzlGaGLBOZDSbCWHZTi4';
